import styled from 'styled-components';
export const StatCard = styled.div `
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  padding: 20px;
  text-align: center;
  transition: all 0.3s ease;
  cursor: default;
  position: relative;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: linear-gradient(90deg, var(--accent-gold, #996515), var(--accent-gold-light, #B8860B));
    opacity: 0;
    transition: opacity 0.3s;
  }

  &:hover::before {
    opacity: 1;
  }

  &:hover {
    border-color: var(--accent-gold-border, rgba(153, 101, 21, 0.25));
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  .stat-value {
    font-family: 'Playfair Display', 'Adamina', serif;
    font-size: 28px;
    color: var(--accent-gold, #996515);
    font-weight: 600;
    margin-bottom: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .stat-label {
    font-size: 12px;
    color: var(--text-secondary);
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  @media (max-width: 768px) {
    padding: 16px;

    .stat-value {
      font-size: 22px;
    }

    .stat-label {
      font-size: 11px;
    }
  }
`;
